<script setup lang="ts">
import type { PropType, Ref } from 'vue';
import { ref, toRefs, watch } from 'vue';
import type {
  CompanyProfileData,
  RegistrationCompanyErrors,
} from '~/pages/registration/components/registration-stages.vue';
import AddUrlsInput from '~/shared/components/form/add-urls-input.vue';
import BaseFormGroup from '~/shared/components/form/base-form-group.vue';
import BaseInput from '~/shared/components/form/input/base-input.vue';

const props = defineProps({
  errors: {
    type: Object as PropType<RegistrationCompanyErrors>,
    required: true,
  },
  isHidden: {
    type: Boolean,
    default: false,
  },
});

const { isHidden } = toRefs(props);

const model = defineModel({
  type: Object as PropType<CompanyProfileData>,
  required: true,
});

const companyNameInputRef = ref<{ inputRef: Ref<HTMLInputElement | null> } | null>(null);

watch(isHidden, () => {
  if (!isHidden.value) {
    if (companyNameInputRef.value?.inputRef?.focus) companyNameInputRef.value?.inputRef?.focus();
  }
});
</script>

<template>
  <div class="flex flex-row w-full min-h-89">
    <div class="flex flex-col md:flex-row gap-8 md:gap-6 lg:gap-10">
      <div class="flex flex-col gap-8 md:gap-10 h-full justify-center">
        <BaseFormGroup class="flex-1" name="companyName" :error="errors.name" label="Company Name">
          <BaseInput
            v-if="!isHidden"
            id="companyName"
            ref="companyNameInputRef"
            v-model="model.name"
            name="companyName"
            placeholder="Company Name"
            :error="errors.name"
            :non-focusable="isHidden"
            class="min-w-80"
          />
        </BaseFormGroup>

        <BaseFormGroup class="flex-1" name="companyUrl" :error="errors.url" label="Company Url">
          <BaseInput
            v-if="!isHidden"
            id="companyUrl"
            v-model="model.url"
            name="companyUrl"
            placeholder="Company Url"
            :error="errors.url"
            :non-focusable="isHidden"
            class="min-w-80"
          />
        </BaseFormGroup>
      </div>

      <div class="flex flex-col gap-8 md:gap-10 h-full justify-center">
        <BaseFormGroup class="flex-1" name="shop-urls" :error="errors.shopUrls" label="Where Going to Sell?">
          <AddUrlsInput
            v-if="!isHidden"
            id="shop-urls"
            v-model="model.shopUrls"
            name="shop-urls"
            placeholder="Shops URLs"
            :error="errors.shopUrls"
            :non-focusable="isHidden"
            class="min-w-80"
          />
        </BaseFormGroup>
      </div>
    </div>
  </div>
</template>
